import { API_STRATEGY } from "../config/legacy-frozen-config";
import {
  engageFetchUserURL,
  toShellUser as engageToShellUser,
  getEngageUser,
} from "./engage/getUser";
import {
  MMFetchPartnerURL,
  toShellPartner as mmToShellPartner,
} from "./mm/getPartner";
import {
  MMFetchUserURL,
  getMmUser,
  toShellUser as mmToShellUser,
} from "./mm/getUser";
import type { ShellPartner, ShellUser } from "./types";

export type Token = {
  token: string;
  parsedToken: {
    sub?: string;
  };
};

type WithToken<T> = (token: string) => Promise<T>;

type ApiStrategy = {
  urls: {
    userUrl: string;
    partnerUrl: string;
  };
  formatters: {
    toShellUser: (x: unknown) => ShellUser;
    toShellPartner: (x: unknown) => ShellPartner;
  };
  getUser: WithToken<ShellUser>;
};

const apiStrategies: Record<typeof API_STRATEGY, ApiStrategy> = {
  engage: {
    urls: {
      userUrl: engageFetchUserURL,
      partnerUrl: "",
    },
    formatters: {
      toShellUser: engageToShellUser,
      toShellPartner: () => {
        console.error("Can't fetch partner on this platform!");
        return {};
      },
    },
    getUser: getEngageUser,
  },
  mm: {
    urls: {
      userUrl: MMFetchUserURL,
      partnerUrl: MMFetchPartnerURL,
    },
    formatters: {
      toShellUser: mmToShellUser,
      toShellPartner: mmToShellPartner,
    },
    getUser: getMmUser,
  },
  cop: {
    urls: {
      userUrl: "",
      partnerUrl: "",
    },
    formatters: {
      // TODO: add function for formatting COP user here
      toShellUser: engageToShellUser,
      toShellPartner: () => {
        console.error("Can't fetch partner on this platform!");
        return {};
      },
    },
    // TODO: add function for getting COP user here
    getUser: getEngageUser,
  },
};

export const apiUrls = apiStrategies[API_STRATEGY].urls;
export const formatters = apiStrategies[API_STRATEGY].formatters;

export const getUser = apiStrategies[API_STRATEGY].getUser;
